import React from 'react';

import Icon from 'components/shared/Icon';
import Close from 'components/shared/Icon/icons/Close';

import s from '../inputs/index.module.css';

function ClearButton({ onClick }: { onClick: () => void }) {
  return (
    <button type="button" className={s.clearButton} onClick={onClick}>
      <Icon component={Close} />
    </button>
  );
}

export { ClearButton };
